import { render, staticRenderFns } from "./RootChrome.vue?vue&type=template&id=55fd0a1f&scoped=true&"
import script from "./RootChrome.vue?vue&type=script&lang=js&"
export * from "./RootChrome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fd0a1f",
  null
  
)

export default component.exports